import { Controller } from "@hotwired/stimulus";

// Connects to data-controller="resumin--accordion"
export default class extends Controller {
  static targets = ["content", "button"];
  static values = {
    defaultOpen: Boolean,
    expandedClass: { type: String, default: "open" },
  };

  connect() {
    if (this.defaultOpenValue) {
      this.contentTarget.classList.add("is-open");
      this.buttonTarget.classList.add(this.expandedClassValue);
    }
  }

  toggle(e) {
    e.preventDefault();
    const button = e.currentTarget;
    const content = this.contentTarget;

    if (content.classList.contains("is-open")) {
      content.classList.remove("is-open");
      button.classList.remove(this.expandedClassValue);
    } else {
      content.classList.add("is-open");
      button.classList.add(this.expandedClassValue);
    }
  }
}
